module.exports = __webpack_public_path__ + "img/share_black_24dp 1.983f7f76.svg";